<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div v-if="viewLoaded">
		<h3 class="mb-3 ml-3"> Konkurs: {{contestConfiguration.name}} ({{contestConfiguration.shortName}})</h3>
		<h3 class="mb-3 ml-3"> Oferta: {{offerData.title || ""}}</h3>
		<v-stepper v-model="viewData.step" :vertical="true">
			<v-stepper-header style="height: auto">
				<template v-for="(section, index) in totalNumberOfSteps">
					<v-stepper-step edit-icon="check" :complete="viewData.step > index+1" :step="index+1" :key="index"
						:editable="true" :title="viewData.titles.allTitles[index]">
					</v-stepper-step>
				</template>
			</v-stepper-header>

			<div v-if="blockActions">
				<v-layout row align-center justify-center>
					<v-flex xs12>
						<v-alert class="ma-4" :value="blockActions" type="warning">
							Tryb podglądu.
						</v-alert>
					</v-flex>
				</v-layout>
				<v-layout row align-center justify-center>
					<v-flex xs8/>
					<v-flex xs4>
						<div style="display: flex; justify-content: center">
							<v-btn @click="editMode" color="primary">Powrót do trybu edycji</v-btn>
						</div>
					</v-flex>
				</v-layout>
			</div>

			<v-stepper-items>
				<v-btn @click="nextStep()" v-if="!isLastStep && !blockActions" :disabled="savingOffer" color="primary" class="right mt-3 mr-2">
					<v-icon class="mr-2 white--text">arrow_forward</v-icon>
					Dalej
				</v-btn>

				<v-btn @click="stepBack()" v-if="!isFirstStep && !blockActions" :disabled="savingOffer" color="default" class="right mt-3 mr-2">
					<v-icon class="mr-2 white--text">arrow_back</v-icon>
					Cofnij
				</v-btn>

				<h2 class="stepTitle">{{stepTitle}}</h2>
				<div class="contest-offer-view-content">
					<vue-form-generator
						name="generator"
						ref="vfg"
						:model="formGenerator.currentModel"
						:options="formGenerator.formOptions"
						:schema="formGenerator.currentSchema"
						:disabled="blockActions"
						v-if="viewData.showGenerator"
					/>
				</div>

				<ContestOfferMainData
					v-if="stepTitle === offerStepNames.MAIN_DATA"
					:readonly="blockActions"
					:contest-configuration="contestConfiguration"
					:contest-id="contestData.id"
					:title.sync="offerData.title"
					:english-title.sync="offerData.englishTitle"
					:priorities-data.sync="offerData.prioritiesData"
					:other-bidders-id.sync="offerData.otherBiddersId"
					:mutual-offer.sync="offerData.mutualOffer"
					@countriesChanged="changeCountries()"
					@biddersChanged="setBiddersChanged()"
					@mutualOfferChanged="(val) => mutualOfferChanged(val)"
					ref="contestOfferMainData"
				></ContestOfferMainData>

				<ContestOfferStats
					v-if="stepTitle === offerStepNames.STATS"
					:readonly="blockActions"
					:contest-id="contestData.id"
					:finances-data.sync="offerData.financesData"
					:priorities-data.sync="offerData.prioritiesData"
					:dac-codes-enabled.sync="offerData.dacCodesEnabled"
					:dac-codes.sync="offerData.dacCodes"
					:countries-changed.sync="offerData.countriesChanged"
					ref="stats"
				></ContestOfferStats>

				<ChooseStartEnd
					v-if="stepTitle === offerStepNames.DATES"
					v-model="offerData.stepsConstantData[currentModuleNumber - 1].dates"
					ref="startEnd"
					:min-date="calculateMinDate()"
					:max-date="calculateMaxDate()"
					:number-of-modules="numberOfModules"
					:module-number="currentModuleNumber"
					:key="'start-end-' + currentModuleNumber"
					:readonly="blockActions"
				></ChooseStartEnd>

				<ChooseVolunteers
					v-if="stepTitle === offerStepNames.DATES && contestConfiguration.volunteersAvailable"
					v-model="offerData.stepsConstantData[currentModuleNumber - 1].volunteers"
					:global-init="offerData.stepsConstantData[currentModuleNumber - 1].globalInitiative"
					:global-init-description="offerData.stepsConstantData[currentModuleNumber - 1].globalInitiativeDescription"
					@change="(val) => globalInitiativeChanged(val)"
					:module-start-date="offerData.stepsConstantData[currentModuleNumber - 1].dates.start"
					:module-end-date="offerData.stepsConstantData[currentModuleNumber - 1].dates.end"
					:volunteers-required="contestConfiguration.volunteersRequired"
					:volunteer-limit="contestConfiguration.volunteerLimit"
					:min-days-abroad="contestConfiguration.minDaysAbroad"
					:number-of-modules="numberOfModules"
					ref="volunteers"
					:key="'volunteers-' + currentModuleNumber"
					:readonly="blockActions"
				></ChooseVolunteers>

				<ChooseActions
					:contest-id="contestData.id"
					v-if="stepTitle === offerStepNames.ACTIONS"
					:actions-data.sync="offerData.stepsConstantData[currentModuleNumber - 1].actionsData"
					:min-start="offerData.stepsConstantData[currentModuleNumber - 1].dates.start"
					:max-end="offerData.stepsConstantData[currentModuleNumber - 1].dates.end"
					:taken-serial-numbers="offerData.stepsConstantData[currentModuleNumber - 1].takenSerialNumbers"
					:module-id="currentModuleNumber - 1"
					:number-of-modules="numberOfModules"
					:module-number="currentModuleNumber"
					:key="'actions-' + currentModuleNumber"
					:readonly="blockActions"
					@importActionsAndCosts=importActionsAndCosts
					ref="actions"
				></ChooseActions>

				<ChooseGeographicalLocations
					v-if="stepTitle === offerStepNames.ACTIONS"
					v-model="offerData.stepsConstantData[currentModuleNumber - 1].locations"
					ref="locations"
					:key="'locations-' + currentModuleNumber"
					:readonly="blockActions"
				></ChooseGeographicalLocations>

				<ActivitiesTableHint
					v-if="stepTitle === offerStepNames.ACTIONS"
					:hint="contestConfiguration.activitiesTableHint"
				></ActivitiesTableHint>

				<CostsTable
					v-if="stepTitle === offerStepNames.COSTS"
					:actions-data.sync="offerData.stepsConstantData[currentModuleNumber - 1].actionsData"
					:administrative-costs.sync="offerData.stepsConstantData[currentModuleNumber - 1].administrativeCosts"
					:taken-serial-numbers="offerData.stepsConstantData[currentModuleNumber - 1].takenSerialNumbers"
					:offer-configuration="contestConfiguration"
					:number-of-modules="numberOfModules"
					:module-number="currentModuleNumber"
					ref="costs"
					:key="'costs' + currentModuleNumber"
					:readonly="blockActions"
				></CostsTable>

				<FinancialTableHint
					v-if="stepTitle === offerStepNames.COSTS"
					:hint="contestConfiguration.financialTableHint"
				></FinancialTableHint>

				<CostsSummaryTable
					v-if="stepTitle === offerStepNames.COSTS_SUMMARY"
					:offer-configuration="contestConfiguration"
					:main-country-id="offerData.prioritiesData.mainCountryId"
					:main-bidder-id="offerData.mainBidderId"
					:contest-id="contestData.id"
					:number-of-modules="numberOfModules"
					:module-number="currentModuleNumber"
					:offer-data-id="offerData.id"
					ref="costsSummary"
					:key="'summary-' + currentModuleNumber"
					:offer-data="offerData"
				></CostsSummaryTable>

				<BidderFundingsTable
					v-if="stepTitle === offerStepNames.COSTS_SHARE && offerData.mutualOffer"
					:actions="offerData.stepsConstantData[currentModuleNumber - 1].actionsData"
					:administrative="offerData.stepsConstantData[currentModuleNumber - 1].administrativeCosts"
					:fundings="offerData.stepsConstantData[currentModuleNumber - 1].bidderFundings"
					:mutual="offerData.mutualOffer"
					:bidders-changed="biddersChanged && !biddersReloaded[currentModuleNumber -1]"
					@reloadFundings="reloadBidderFundings"
					ref="bidderFundings"
					:number-of-modules="numberOfModules"
					:module-number="currentModuleNumber"
					:key="'fundings-' + currentModuleNumber"
					:readonly="blockActions"
				></BidderFundingsTable>

				<v-layout mt-3 v-if="!blockActions">
					<v-spacer/>
					<v-btn @click="$router.go(-1)" v-if="isFirstStep" color="blue" class="mr-2">
						<v-icon class="mr-2">close</v-icon>
						Anuluj
					</v-btn>

					<v-btn @click="saveOffer(true, viewData.step)" :disabled="savingOffer" color="blue" class="mr-2">
						<v-icon class="mr-2">save</v-icon>
						Zapisz ofertę
					</v-btn>

					<v-btn @click="stepBack()" v-if="!isFirstStep" :disabled="savingOffer" color="default" class="mr-2">
						<v-icon class="mr-2 white--text">arrow_back</v-icon>
						Cofnij
					</v-btn>

					<v-btn @click="nextStep()" v-if="!isLastStep" :disabled="savingOffer" color="primary" class="mr-2">
						<v-icon class="mr-2 white--text">arrow_forward</v-icon>
						Dalej
					</v-btn>

					<v-btn @click="viewData.completeOfferDialog = true" :disabled="savingOffer" color="primary" class="mr-2"
						v-if="isLastStep && (offerData.mutualOffer || roles.isSubBidder())">
						<v-icon class="mr-2">check</v-icon>
						Zakończ wypełnianie oferty
					</v-btn>

					<v-btn @click="viewData.sendOfferDialog = true" color="primary" class="mr-2"
						v-if="isLastStep && !offerData.mutualOffer && roles.isBidder()">
						<v-icon color="white" class="mr-2 white--text">send</v-icon>
						Zakończ i wyślij ofertę
					</v-btn>
				</v-layout>

				<v-alert :value="offerData.mutualOffer" color="lightred" type="warning" v-if="isLastStep">
					Oferta nie została jeszcze zaakceptowana przez pozostałych oferentów. Oferenci otrzymają prośbę
					o potwierdzenie oferty dopiero gdy zakończysz jej wypełnianie.
				</v-alert>

				<v-alert :value="roles.isSubBidder()" type="warning" v-if="isLastStep">
					Oferta wymaga potwierdzenia przez głównego oferenta. Oferent główny otrzyma prośbę
					o potwierdzenie oferty dopiero gdy zakończysz jej wypełnianie.
				</v-alert>

			</v-stepper-items>
		</v-stepper>

		<ContestOfferInfoDialog :action="closePeekModeWarning" :dialog-model="viewData.peekModeWarning"
			header="Przejście do trybu podglądu" content="Nastąpiło przejście do trybu podglądu. Aby edytować/zapisywać ofertę, należy wrócić do trybu edycji."/>

		<ContestOfferConfirmationDialog :action="sendOffer" :dialog-model="viewData.sendOfferDialog"
			@close-confirmation="viewData.sendOfferDialog = false" action-label="Wyślij" :disabled="savingOffer"
			content="Upewnij się, że wypełniłeś poprawnie formularz zanim zatwierdzisz ofertę.
				Po zatwierdzeniu nie będzie możliwości edycji!" header="Wysyłka oferty" icon="send"/>

		<ContestOfferConfirmationDialog :action="completeOffer"
			:dialog-model="viewData.completeOfferDialog" :disabled="savingOffer"
			@close-confirmation="viewData.completeOfferDialog = false" action-label="Zakończ i wyślij"
			content="Upewnij się, że poprawnie wypełniłeś formularz.
				Po wysłaniu oferty nie będzie możliwości powrotu do jej edycji!" header="Koniec wypełniania oferty"
			:info="(subBidderType === 'COWORKER' && roles.isSubBidder()) ? 'Oferta zostanie wysłana do akceptacji przez koordynatora konta.' : ''"
			icon="check">
			<!-- <div>
				<v-tooltip top v-if="subBidderType === 'SUBSIDIARY' && roles.isSubBidder()">
					<template v-slot:activator="{ on }">
						<div v-on="on">
							<v-checkbox
								class="ml-3"
								label="Pozwól na edycję przez głównego oferenta"
								v-model="offerData.allowMainBidderChanges"
								aria-label="allow main bidder changes"/>
						</div>
					</template>
					<span>
						Pozwól głównemu oferentowi na dokonywanie zmian w wysłanej ofercie.<br/>
						W przeciwnym wypadku główny oferent nie może edytować wysłanej oferty.
					</span>
				</v-tooltip>
			</div> -->
		</ContestOfferConfirmationDialog>

		<EgrantyErrorListPopup
			title="Nie udało się wysłać oferty:"
			:error-list="sendOfferErrors.messages"
			:is-open="sendOfferErrors.showPopup"
			@close="closeSendOfferErrorsPopup"
		/>

	</div>
</template>
<script>
	import Vue from "vue";
	import {genericFormUtil} from "@/utils/genericFormUtil";
	import VueFormGenerator from "vue-form-generator";
	import ChooseActions from "./components/ChooseActions";
	import {Offer} from "@/api/generated/Offer";
	import ContestOfferConfirmationDialog from "./components/ContestOfferConfirmationDialog";
	import CostsTable from "./components/CostsTableComponents/CostsTable";
	import CostsSummaryTable from "./components/CostsSummaryTable";
	import BidderFundingsTable from "./components/BidderFundingsTable";
	import ChooseVolunteers from "./components/ChooseVolunteers";
	import ChooseGeographicalLocations from "./components/ChooseGeographicalLocations";
	import ChooseStartEnd from "./components/ChooseStartEnd";
	import {Api} from "@/api";
	import EgrantyErrorListPopup from "../../../genericComponents/EgrantyErrorListPopup";
	import FinancialTableHint from "./components/FinancialTableHint";
	import ActivitiesTableHint from "./components/ActivitiesTableHint";
	import {SubBidder} from "@/api/generated/SubBidder";
  import ContestOfferInfoDialog from "@/view/logged/offer/components/ContestOfferInfoDialog";
  import ContestOfferMainData from "@/view/logged/offer/components/ContestOfferMainData";
  import ContestOfferStats from "@/view/logged/offer/components/ContestOfferStats";
  import {OfferStepNames} from "@/utils/OfferStepNames";
  import {Dates} from "@/utils/Dates";

	Vue.use(VueFormGenerator);

	export default {
		name: "ContestOfferView",
		components: {
      ContestOfferStats,
      ContestOfferMainData,
      ContestOfferInfoDialog,
			FinancialTableHint,
			ActivitiesTableHint,
			EgrantyErrorListPopup,
			ChooseGeographicalLocations,
			ChooseVolunteers,
			ContestOfferConfirmationDialog,
			ChooseActions,
			CostsTable,
			CostsSummaryTable,
			BidderFundingsTable,
			ChooseStartEnd,
		},
		mixins: [Dates],
		watch: {
			"formGenerator.currentModel": {
				// byc moze trzeba bedzie zrefaktoryzowac to, odpala sie to co zmiane znaku
				handler() {
					if (this.viewLoaded && this.isGenericPersistentStep()) {
						this.applyGenericPersistentForm();
					}

					if (this.viewLoaded && this.isGenericModuleStep()) {
						this.applyGenericModuleForm();
					}
				},
				deep: true,
			},

			"viewData.step": { // krok, może zostać zmieniony poprzez kliknięcie w stepper-header-step lub poprzez nextStep
        // jest też ustawiany w loadData, dlatego w handlerze sprawdzamy, czy to inicjalizacja kroku
				handler(newValue, oldValue) {
          this.handleStepChange(newValue, oldValue);
				},
			},
		},

		computed: {
			currentModuleNumber() {
				let step = this.viewData.step;
				let number = 1;
				if (this.isModuleOffer()) {
					for (let i = 0; i < this.numberOfModules; i++) {
						if ((step > this.numberOfFirstNotModuleSteps + i * (this.numberOfConstFieldsModuleSteps + this.numberOfGenericModularSteps))
							&& (step <= this.numberOfFirstNotModuleSteps + (i + 1) * (this.numberOfConstFieldsModuleSteps + this.numberOfGenericModularSteps))) {
							return number;
						}
						number++;
					}
				} else {
					return 1;
				}
				return 1;
			},

			viewLoaded() {
				return this.offerDataLoaded && this.contestConfigurationLoaded;
			},

			stepTitle() {
				return this.viewData.titles.allTitles[this.viewData.step - 1];
			},

			numberOfModules() {
				return this.contestConfiguration.numberOfModules;
			},

			isFirstStep() {
				return this.viewData.step === 1;
			},

			isLastStep() {
				return this.viewData.step === this.totalNumberOfSteps;
			},

			totalNumberOfSteps() {
				if (this.isModuleOffer()) {
					return this.numberOfFirstNotModuleSteps
						+ this.numberOfModules * (this.numberOfConstFieldsModuleSteps + this.numberOfGenericModularSteps)
						+ this.numberOfGenericPersistentSteps + this.numberOfLastNotGenericSteps;
				} else {
					// oferty niemodulowe, traktujemy jakby byl jeden modul bez formularza generycznego powtarzanego dla wszystkich modulow
					return this.numberOfFirstNotModuleSteps
						+ this.numberOfConstFieldsModuleSteps + this.numberOfGenericPersistentSteps + this.numberOfLastNotGenericSteps;
				}
			},

			numberOfFirstNotModuleSteps() {
				return this.viewData.titles.firstNotModuleStepTitles.length;
			},

			numberOfConstFieldsModuleSteps() {
				return this.offerData.mutualOffer ? this.viewData.titles.moduleConstFieldSteps.length : this.viewData.titles.moduleConstFieldSteps.length - 1;
			},

			numberOfGenericModularSteps() {
				if (this.contestConfiguration.moduleSchema) {
					return this.contestConfiguration.moduleSchema.sections.length;
				} else {
					return 0;
				}
			},

			numberOfGenericPersistentSteps() {
				return this.contestConfiguration.persistentSchema.sections.length;
			},

			numberOfLastNotGenericSteps() {
				return this.viewData.titles.lastNotGenericStepTitles.length;
			},
		},

		data() {
			return {
				biddersChanged: false,
				savingOffer: false,
        blockActions: false,
        stepChangeWithValidation: false,
        stepInit: true,

				biddersReloaded: [],

				contestData: {
					id: this.$route.params.id,
				},

				// tutaj pakujemy dane z konfiguracji konkursu
				contestConfiguration: {
					numberOfModules: 0,
					moduleSchema: null,
					persistentSchema: null,
					firstPossibleOfferDate: "",
					lastPossibleOfferDate: "",
					manyAccreditationCountries: false,
					activitiesTableHint: "",
					financialTableHint: "",
					name: "",
					shortName: "",
					moduleTimePossibility: [],
				},

				// tutaj pakujemy dane oferty
				offerData: {
          version: null,
					step: 1,
					id: this.$route.params.offerId,
					title: "",
					englishTitle: "",
					otherBiddersId: [],
					prioritiesData: {
						selected: [],
						extraCountries: [],
					},
					stepsConstantData: [],
					financesData: {
						countriesFundings: [],
						totalFundings: "",
					},
					dacCodes: [],
					moduleGenericModel: undefined,
					genericModel: undefined,
					mutualOffer: false,
					countriesChanged: false,
					allowMainBidderChanges: null,
				},

				formGenerator: {
					currentSchema: {},
					currentModel: {},
					formOptions: {
						validateAfterLoad: false,
						validateAfterChanged: true,
						validateAsync: true,
					},
					currentConditionalBooleans: [],
				},

				sendOfferErrors: {
					showPopup: false,
					messages: [],
				},

        offerStepNames: OfferStepNames,

				viewData: {
					step: null,
					showGenerator: false,
					titles: {
						firstNotModuleStepTitles: [OfferStepNames.MAIN_DATA, OfferStepNames.STATS], // w zaleznosci od ilosci tytulow oblicza sie ilosc poszczegolnych krokow...
						lastNotGenericStepTitles: [OfferStepNames.SEND_OFFER],
						moduleConstFieldSteps: [OfferStepNames.DATES, OfferStepNames.ACTIONS, OfferStepNames.COSTS, OfferStepNames.COSTS_SUMMARY, OfferStepNames.COSTS_SHARE],
						allTitles: [],
					},
					sendOfferDialog: false,
					completeOfferDialog: false,
          peekModeWarning: false,
				},
				contestConfigurationLoaded: false,
				offerDataLoaded: false,
				subBidderType: "",
			};
		},

		created() {
			this.loadData();
		},

    async beforeDestroy() {
      if (this.stepTitle !== OfferStepNames.SEND_OFFER) {
        await this.saveOffer(false, this.viewData.step);
      }
    },

    methods: {
		calculateMinDate(){
			if(!this.contestConfiguration.moduleTimePossibility){
				return this.contestConfiguration.firstPossibleOfferDate;
			}

			let moduleTimePossibility = this.contestConfiguration.moduleTimePossibility.find(x=>x.moduleNumber == this.currentModuleNumber);
			if(!moduleTimePossibility){
				return this.contestConfiguration.firstPossibleOfferDate;
			}
			return this.getMaxStringDate([this.contestConfiguration.firstPossibleOfferDate, moduleTimePossibility.moduleStartDate]);
		},
		calculateMaxDate(){
			if(!this.contestConfiguration.moduleTimePossibility){
				return this.contestConfiguration.lastPossibleOfferDate;
			}
			let moduleTimePossibility = this.contestConfiguration.moduleTimePossibility.find(x=>x.moduleNumber == this.currentModuleNumber);
			if(!moduleTimePossibility){
				return this.contestConfiguration.lastPossibleOfferDate;
			}
			return this.getMinStringDate([this.contestConfiguration.lastPossibleOfferDate, moduleTimePossibility.moduleEndDate]);
		},
			async loadData() {
				await Api.syncGet(this, "/public-contest/offer-configuration?offerId=".concat(this.offerData.id), response => {
						this.initializeContestConfiguration(response);
						// inicjalizuje schematy generycznego formularza
						this.initializeGenericSchemas(response);
						// inicjalizujemy wartosci generycznego formularza w ofercie
						this.contestConfigurationLoaded = true;
					},
					errorResponse => this.$messagesBus.$emit("error", "Nie udało się wczytać konfiguracji oferty!", errorResponse),
				);
				// Pobranie danych oferty
				await Api.syncGet(
					this,
					"/offer/data?offerId=".concat(this.offerData.id),
					response => {
            this.stepInit = true;
						for (let field in response) {
							this.$set(this.offerData, field, response[field]);
						}
						this.contestConfiguration.numberOfModules = this.resolveNumberOfModules(response);
						this.initializeGenericModel(response);
						this.offerDataLoaded = true;
						this.initializeStepTitles();
            if (this.viewData.step === response.step) {
              this.handleStepChange(response.step, response.step);
            } else {
              this.viewData.step = response.step;
            }
					},
					errorResponse => this.$messagesBus.$emit("error", "Nie udało się wczytać oferty!", errorResponse),
				);

				if (this.roles.isSubBidder()) {
					SubBidder.getSubBidderType(this,
						success => {
							this.subBidderType = success.subBidderType;
						});
				}
			},

			initializeContestConfiguration(response) {
				this.contestConfiguration.moduleSchema = genericFormUtil.decodeSchema(response.moduleSchema);
				this.contestConfiguration.persistentSchema = genericFormUtil.decodeSchema(response.persistentSchema);
				this.contestConfiguration.firstPossibleOfferDate = response.firstPossibleOfferDate;
				this.contestConfiguration.lastPossibleOfferDate = response.lastPossibleOfferDate;
				this.contestConfiguration.volunteersAvailable = response.volunteersAvailable;
				this.contestConfiguration.volunteerLimit = response.volunteerLimit;
				this.contestConfiguration.minDaysAbroad = response.minDaysAbroad;
				this.contestConfiguration.manyAreas = response.manyAreas;
				this.contestConfiguration.manyPriorities = response.manyPriorities;
				this.contestConfiguration.manyTasks = response.manyTasks;
				this.contestConfiguration.manyAccreditationCountries = response.manyAccreditationCountries;
				this.contestConfiguration.volunteersRequired = response.volunteersRequired;
				this.contestConfiguration.activitiesTableHint = response.activitiesTableHint;
				this.contestConfiguration.financialTableHint = response.financialTableHint;
				this.contestConfiguration.name = response.name;
				this.contestConfiguration.shortName = response.shortName;
				this.contestConfiguration.moduleTimePossibility = response.moduleTimePossibility;
				this.contestConfiguration.modulePriceLimit = response.modulePriceLimit;
				this.contestConfiguration.dacCodesEnabled = response.dacCodesEnabled;
			},

			validateExistingRef(name) {
				if (this.$refs[name] === undefined) {
					return true;
				}
				if (typeof this.$refs[name]["validate"] !== "function") {
					return true;
				}
				return this.$refs[name].validate();
			},

			validateNonGeneric() {
				let valid = this.validateExistingRef("contestOfferMainData");
				valid &= this.validateExistingRef("stats");
				valid &= this.validateExistingRef("actions");
				valid &= this.validateExistingRef("startEnd");
				valid &= this.validateExistingRef("volunteers");
				valid &= this.validateExistingRef("costs");
				valid &= this.validateExistingRef("costsSummary");
				valid &= this.validateExistingRef("bidderFundings");
				valid &= this.validateExistingRef("locations");
				return valid;
			},

      async handleStepChange(newValue, oldValue) {
        if (this.stepInit) {
          this.stepInit = !this.stepInit;
          this.changingStepAction();
          return;
        }
        if (!this.blockActions && !this.stepChangeWithValidation && newValue > oldValue) {
          this.blockActions = true;
          this.viewData.peekModeWarning = true;
        }
        this.stepChangeWithValidation = false;
        this.changingStepAction();
      },

      editMode() {
        this.blockActions = false;
        this.loadData();
      },

      closePeekModeWarning() {
        this.viewData.peekModeWarning = false;
      },

			async nextStep() {
				let valid = await this.validate();
				valid &= this.validateNonGeneric();
				if (!valid) {
					this.$messagesBus.$emit("error", "Formularz zawiera błędy");
					return;
				}

				this.saveInViewCurrentStepState();
        this.stepChangeWithValidation = true;
				await this.saveOffer(false, this.viewData.step + 1);
				this.changingStepAction();
			},

			async stepBack() {
				this.saveInViewCurrentStepState();
        await this.saveOffer(false, this.viewData.step - 1);
				this.changingStepAction();
				this.viewData.sendOfferDialog = false;
			},

			async validate() {
				let isValid = true;
				if (this.isConstFieldsFirstSteps()) {
					return isValid;
				}

				if (this.isConstFieldsModuleStep()) {
					return isValid;
				}

				if (this.isGenericModuleStep()) {
					let validationPromise = await this.validateGenericForm();
					if (validationPromise.length > 0) {
						isValid = false;
					}
					return isValid;
				}

				if (this.isGenericPersistentStep()) {
					let validationPromise = await this.validateGenericForm();
					if (validationPromise.length > 0) {
						isValid = false;
					}
					return isValid;

				}

				if (this.isLastNotGenericSteps()) {
					return isValid;
				}
				return isValid;
			},

			async validateGenericForm() {
				return this.$refs.vfg.validate();
			},

			saveInViewCurrentStepState() {

				if (this.isGenericModuleStep()) {
					this.offerData.moduleGenericModel[this.currentModuleNumber].sections[this.resolveSectionIndexInGenericModule()].fields = this.formGenerator.currentModel;
				}

				if (this.isGenericPersistentStep()) {
					this.offerData.genericModel.sections[this.resolveSectionIndexInPersistentSchema()].fields = this.formGenerator.currentModel;
				}
			},

			initializeGenericModel(response) {
				this.offerData.genericModel = this.getPersistentModel(response);
				this.offerData.moduleGenericModel = this.getModuleModel(response);
			},

			getModuleModel(response) {
				if (this.isModuleOffer()) {
					let map = {};
					for (let i = 1; i <= this.numberOfModules; i++) {
						if (response.moduleGenericModel[i]) {
							map[i] = genericFormUtil.decodeSchema(response.moduleGenericModel[i]);
						} else {
							map[i] = genericFormUtil.buildModelFromSchema(this.contestConfiguration.moduleSchema);
						}
					}
					return map;
				}
				return null;
			},

			changeCountries() {
				this.offerData.countriesChanged = true;
			},

			getPersistentModel(response) {
				if (response.persistentGenericModel) {
					return genericFormUtil.decodeSchema(response.persistentGenericModel);
				}
				return genericFormUtil.buildModelFromSchema(this.contestConfiguration.persistentSchema);
			},

			initializeGenericSchemas(response) {
				this.contestConfiguration.persistentSchema = this.getPersistentSchema(response);
				this.contestConfiguration.moduleSchema = this.getModuleSchema(response);
			},

			initializeStepTitles() {
				this.viewData.titles.allTitles = [];
				this.viewData.titles.firstNotModuleStepTitles.forEach(title => {
					this.viewData.titles.allTitles.push(title);
				});
				if (this.isModuleOffer()) {
					for (let i = 0; i < this.numberOfModules; i++) {
						this.viewData.titles.moduleConstFieldSteps.forEach(title => {
							if (title !== OfferStepNames.COSTS_SHARE || this.offerData.mutualOffer) {
								this.viewData.titles.allTitles.push(title);
							}

						});
						for (let j = 0; j < this.numberOfGenericModularSteps; j++) {
							this.viewData.titles.allTitles.push(
								this.contestConfiguration.moduleSchema.sections[j].name.concat(this.numberOfModules > 1 ? " (Moduł " + (i + 1) + ")" : ""));
						}
					}
				} else {
					this.viewData.titles.moduleConstFieldSteps.forEach(title => {
						if (title !== OfferStepNames.COSTS_SHARE || this.offerData.mutualOffer) {
							this.viewData.titles.allTitles.push(title);
						}
					});
					this.viewData.titles.allTitles.push();
				}

				for (let i = 0; i < this.numberOfGenericPersistentSteps; i++) {
					this.viewData.titles.allTitles.push(this.contestConfiguration.persistentSchema.sections[i].name);
				}
				this.viewData.titles.lastNotGenericStepTitles.forEach(title => {
					this.viewData.titles.allTitles.push(title);
				});

			},

			resolveNumberOfModules(response) {
				// zwraca 0 w przypadku gdy nie jest to oferta modulowa, może też być 1 modul, wtedy zwraca 1 oraz n, wtedy n.
				return Object.keys(response.moduleGenericModel).length;
			},

			getModuleSchema(response) {
				if (response.moduleSchema) {
					return genericFormUtil.decodeSchema(response.moduleSchema);
				}
				return null;
			},

			getPersistentSchema(response) {
				return genericFormUtil.decodeSchema(response.persistentSchema);
			},

			isModuleOffer() {
				return this.numberOfModules > 0;
			},

			changingStepAction() {
				if (this.isGenericModuleStep()) {
					this.applyGenericModuleForm();
					this.viewData.showGenerator = true;
				} else if (this.isGenericPersistentStep()) {
					this.applyGenericPersistentForm();
					this.viewData.showGenerator = true;
				} else {
					this.viewData.showGenerator = false;
				}
				this.$vuetify.goTo(0, {easing: "linear"});
			},

			isConstFieldsFirstSteps() {
				let step = this.viewData.step;
				if (step <= this.numberOfFirstNotModuleSteps) {
					return true;
				}
			},

			isConstFieldsModuleStep() {
				let step = this.viewData.step;
				// dla ofert modulowych
				if (this.isModuleOffer()) {
					for (let i = 0; i < this.numberOfModules; i++) {
						if ((step > this.numberOfFirstNotModuleSteps + i * (this.numberOfConstFieldsModuleSteps + this.numberOfGenericModularSteps))
							&& (step <= this.numberOfFirstNotModuleSteps + (i + 1) * this.numberOfConstFieldsModuleSteps + i * this.numberOfGenericModularSteps)) {
							return true;
						}
					}
					return false;
					// dla ofert niemodulowych
				} else {
					return step > this.numberOfFirstNotModuleSteps && step <= this.numberOfFirstNotModuleSteps + this.numberOfConstFieldsModuleSteps;
				}
			},

			isGenericPersistentStep() {
				let step = this.viewData.step;
				return (step > this.totalNumberOfSteps - this.numberOfLastNotGenericSteps - this.numberOfGenericPersistentSteps) && (step <= this.totalNumberOfSteps - this.numberOfLastNotGenericSteps);
			},

			isLastNotGenericSteps() {
				let step = this.viewData.step;
				return (step >= this.totalNumberOfSteps - this.numberOfLastNotGenericSteps) && (step <= this.totalNumberOfSteps);
			},

			isGenericModuleStep() {
				let step = this.viewData.step;
				for (let i = 0; i < this.numberOfModules; i++) {
					if ((step > this.numberOfFirstNotModuleSteps + (i + 1) * this.numberOfConstFieldsModuleSteps + i * this.numberOfGenericModularSteps)
						&& (step <= this.numberOfFirstNotModuleSteps + (i + 1) * (this.numberOfConstFieldsModuleSteps + this.numberOfGenericModularSteps))) {
						return true;
					}
				}
				return false;
			},

			applyGenericForm(sections, sectionIndex, contestFormSchema) {
				this.formGenerator.currentModel = sections[sectionIndex].fields;
				let schema = genericFormUtil.getSectionSchemaFromSchema(contestFormSchema, sectionIndex);
				if (genericFormUtil.sectionSchemaContainsConditionalField(schema)) {
					let schemaValues = sections[sectionIndex].fields;
					this.formGenerator.currentSchema = genericFormUtil.filterSchemaByConditionalFieldsValue(schema, schemaValues);
					let indexes = genericFormUtil.calculateIndexes(schema);
					this.formGenerator.currentConditionalHashes = genericFormUtil.getConditionalValueHashes(schema, indexes);
				} else {
					this.formGenerator.currentSchema = schema;
				}
				this.viewData.showGenerator = true;
			},

			applyGenericModuleForm() {
				let moduleNumber = this.currentModuleNumber;
				let sections = this.offerData.moduleGenericModel[moduleNumber].sections;
				let currentSectionIndex = this.resolveSectionIndexInGenericModule();
				this.applyGenericForm(sections, currentSectionIndex, this.contestConfiguration.moduleSchema);
			},

			applyGenericPersistentForm() {
				let sections = this.offerData.genericModel.sections;
				let currentSectionIndex = this.resolveSectionIndexInPersistentSchema();
				this.applyGenericForm(sections, currentSectionIndex, this.contestConfiguration.persistentSchema);
			},

			resolveSectionIndexInPersistentSchema() {
				return this.numberOfGenericPersistentSteps - (this.totalNumberOfSteps - this.numberOfLastNotGenericSteps - this.viewData.step) - 1;
			},

			resolveSectionIndexInGenericModule() {
				let moduleNumber = this.currentModuleNumber;
				return this.viewData.step - this.numberOfFirstNotModuleSteps - moduleNumber * this.numberOfConstFieldsModuleSteps - (moduleNumber - 1) * this.numberOfGenericModularSteps - 1;
			},

			resolveSectionIndexInConstFieldModule() {
				let step = this.viewData.step;
				// dla ofert modulowych
				if (this.isModuleOffer()) {
					for (let i = 0; i < this.numberOfModules; i++) {
						if ((step > this.numberOfFirstNotModuleSteps + i * (this.numberOfConstFieldsModuleSteps + this.numberOfGenericModularSteps))
							&& (step <= this.numberOfFirstNotModuleSteps + (i + 1) * this.numberOfConstFieldsModuleSteps + i * this.numberOfGenericModularSteps)) {
							return step - (this.numberOfFirstNotModuleSteps + i * (this.numberOfConstFieldsModuleSteps + this.numberOfGenericModularSteps)) - 1;
						}
					}
					// dla ofert niemodulowych
				} else {
					return step - this.numberOfFirstNotModuleSteps - 1;
				}
			},

			resolveSectionIndexInFirstConstSteps() {
				return this.viewData.step - 1;
			},

			resolveSectionIndexInLastConstSteps() {
				return this.numberOfLastNotGenericSteps - (this.totalNumberOfSteps - this.viewData.step);
			},

			closeSendOfferErrorsPopup() {
				this.sendOfferErrors.showPopup = false;
			},

      sendOffer() {
        this.savingOffer = true;
        Offer.postSubmit(this, this.offerData.id, successResponse => {
              this.savingOffer = false;
              this.$router.push("/app/contest/" + this.contestData.id + "/my-offer-list");
              this.$messagesBus.$emit("success", "Oferta wysłana pomyślnie", successResponse);
            },
            errorResponse => {
              this.handleOfferSendingErrors(errorResponse);
              this.savingOffer = false;
            });
      },

      handleOfferSendingErrors(errorResponse) {
        this.sendOfferErrors.messages = errorResponse.message.split("\n");
        if (this.sendOfferErrors.messages && this.sendOfferErrors.messages[0] === "OFFER_LIMIT_EXCEEDED") {
          this.sendOfferErrors.messages.shift();
          let errors = this.sendOfferErrors.messages.map(message => message.concat(": przekroczono limit ofert."));
          if (errors.length) {
            this.sendOfferErrors.messages = errors;
            this.sendOfferErrors.showPopup = true;
          }
          this.$messagesBus.$emit("error", "Przekroczono limit ofert w tym konkursie", errorResponse);
        } else {
          this.sendOfferErrors.messages.pop();
          if (this.sendOfferErrors.messages.length) {
            this.sendOfferErrors.showPopup = true;
          }
          this.$messagesBus.$emit("error", "Nie udało się wysłać oferty", errorResponse);
        }
      },

			completeOffer() {
        Offer.postComplete(this, this.offerData.id, successResponse => {
              this.unlockOffer();
              this.$router.push("/app/contest/" + this.contestData.id + "/my-offer-list");
              this.$messagesBus.$emit("success", "Oferta zatwierdzona pomyślnie", successResponse);
            },
            errorResponse => {
              this.unlockOffer();
              this.handleOfferSendingErrors(errorResponse);
            });
			},

      async saveOffer(showMessage, step) {
        this.lockOffer();

        if (this.stepTitle === OfferStepNames.MAIN_DATA) {
          Offer.putMainData(this, this.offerData.id, this.prepareMainDataDTO(step), this.offerSaveSuccessHandler(showMessage, step), this.offerSaveErrorHandler());
        } else if (this.stepTitle === OfferStepNames.STATS) {
          Offer.putStats(this, this.offerData.id, this.prepareStatsDTO(step), this.offerSaveSuccessHandler(showMessage, step), this.offerSaveErrorHandler());
        } else if (this.stepTitle === OfferStepNames.DATES) {
          Offer.putModuleDatesAndVolunteers(this, this.offerData.id, this.prepareModuleDatesAndVolunteersDTO(step), this.offerSaveSuccessHandler(showMessage, step), this.offerSaveErrorHandler());
        } else if (this.stepTitle === OfferStepNames.ACTIONS || this.stepTitle === OfferStepNames.COSTS) {
          Offer.putModuleActionsAndCosts(this, this.offerData.id, this.prepareModuleActionsAndCostsDTO(step), this.offerSaveSuccessHandler(showMessage, step), this.offerSaveErrorHandler());
        } else if (this.stepTitle === OfferStepNames.COSTS_SHARE) {
          Offer.putCostsShare(this, this.offerData.id, this.prepareCostsShareDTO(step), this.offerSaveSuccessHandler(showMessage, step), this.offerSaveErrorHandler());
        } else if (this.isGenericPersistentStep()) {
          Offer.putGenericPersistentForm(this, this.offerData.id, this.prepareGenericPersistentFormDTO(step), this.offerSaveSuccessHandler(showMessage, step), this.offerSaveErrorHandler());
        } else if (this.isGenericModuleStep()) {
          Offer.putGenericModuleForm(this, this.offerData.id, this.prepareGenericModuleFormDTO(step), this.offerSaveSuccessHandler(showMessage, step), this.offerSaveErrorHandler());
        } else if (this.stepTitle === OfferStepNames.COSTS_SUMMARY || this.stepTitle === OfferStepNames.SEND_OFFER) {
          Offer.putStep(this, this.offerData.id, this.prepareStepDTO(step), this.offerSaveSuccessHandler(showMessage, step), this.offerSaveErrorHandler());
        } else {
          this.$messagesBus.$emit("error", "Nie udało się zapisać oferty (" + this.stepTitle + ")");
          this.unlockOffer();
        }
      },

	  importActionsAndCosts(copiedModule){
		this.lockOffer();
		Offer.putCopyModuleActionsAndCosts(this, this.offerData.id, this.prepareModuleActionsAndCostsCopyDTO(this.viewData.step, copiedModule), 
		successResponse => {
          this.$messagesBus.$emit("success", "Koszty programowe zostały skopiowane");
		  this.loadData();
          this.unlockOffer();
        }, 
		errorResponse => {
          let errorMessage = "";
          if (errorResponse.message === "Version mismatch") {
            errorMessage = ", ponieważ oferta została w międzyczasie zmodyfikowana";
          }
          this.$messagesBus.$emit("error", "Nie udało się skopiować kosztów programowych" + errorMessage);
          this.unlockOffer();
        }
		);
		this.unlockOffer();
	  },

      offerSaveSuccessHandler(showMessage, step) {
        return successResponse => {
          this.offerData.version = successResponse;
          this.offerData.step = this.viewData.step = step;
          if (showMessage) {
            this.$messagesBus.$emit("success", "Oferta zapisana pomyślnie");
          }
          this.unlockOffer();
        };
      },

      offerSaveErrorHandler() {
      return errorResponse => {
          let errorMessage = "";
          if (errorResponse.message === "Version mismatch") {
            errorMessage = ", ponieważ została w międzyczasie zmodyfikowana";
          }
          this.$messagesBus.$emit("error", "Nie udało się zapisać oferty" + errorMessage);
          this.unlockOffer();
        };
      },

      lockOffer() {
        this.savingOffer = true;
      },

      unlockOffer() {
        this.savingOffer = false;
      },

			mutualOfferChanged(val) {
				this.offerData.mutualOffer = val;
				this.offerData.otherBiddersId = [];
				this.initializeStepTitles();
			},

			globalInitiativeChanged(val) {
				this.offerData.stepsConstantData[this.currentModuleNumber - 1].globalInitiative = val.isGlobal;
				this.offerData.stepsConstantData[this.currentModuleNumber - 1].globalInitiativeDescription = val.isGlobal ? val.description : null;
			},

			setBiddersChanged() {
				this.biddersChanged = true;
				this.biddersReloaded = [];
				for (let moduleNum = 0; moduleNum < this.numberOfModules; moduleNum++) {
					this.biddersReloaded.push(false);
				}
			},

			reloadBidderFundings() {
				Offer.getBidderFundings(this, this.$route.params.offerId, this.currentModuleNumber, response => {
					this.offerData.stepsConstantData[this.currentModuleNumber - 1].bidderFundings = response;
					this.biddersReloaded[this.currentModuleNumber - 1] = true;
					if (this.allBiddersReloaded()) {
						this.biddersChanged = false;
					}
				});
			},

			allBiddersReloaded() {
				let ret = true;
				for (let module = 0; module < this.numberOfModules; module++) {
					ret &= this.biddersReloaded[module];
				}
				return ret;
			},

      prepareStepDTO(step) {
        return {
          version: this.offerData.version,
          step: step,
        };
      },

      prepareMainDataDTO(step) {
        return {
          version: this.offerData.version,
          step: step,
          title: this.offerData.title,
          englishTitle: this.offerData.englishTitle,
          countriesChanged: this.offerData.countriesChanged,
          mutualOffer: this.offerData.mutualOffer,
          otherBiddersId: this.offerData.otherBiddersId,
          prioritiesData: this.offerData.prioritiesData,
        };
      },

      prepareStatsDTO(step) {
        return {
          version: this.offerData.version,
          step: step,
          countriesChanged: this.offerData.countriesChanged,
          prioritiesData: this.offerData.prioritiesData,
          financesData: this.offerData.financesData,
          dacCodes: this.offerData.dacCodes,
        };
      },

      prepareModuleDatesAndVolunteersDTO(step) {
        let moduleData = this.offerData.stepsConstantData[this.currentModuleNumber - 1];
        return {
          version: this.offerData.version,
          step: step,
          module: this.currentModuleNumber,
          globalInitiative: moduleData.globalInitiative,
          globalInitiativeDescription: moduleData.globalInitiativeDescription,
          volunteers: moduleData.volunteers,
          dates: moduleData.dates,
        };
      },

      prepareModuleActionsAndCostsDTO(step) {
        let moduleData = this.offerData.stepsConstantData[this.currentModuleNumber - 1];
        return {
          version: this.offerData.version,
          step: step,
          module: this.currentModuleNumber,
          administrativeCosts: moduleData.administrativeCosts,
          actionsData: moduleData.actionsData,
          actionsCosts: moduleData.actionsCosts,
          actionsCostsActionIds: moduleData.actionsCostsActionIds,
          locations: moduleData.locations,
        };
      },

	  prepareModuleActionsAndCostsCopyDTO(step, copiedModule){
		return {
          version: this.offerData.version,
          step: step,
          module: this.currentModuleNumber,
		  copiedModule: copiedModule
		};
	  },

      prepareCostsShareDTO(step) {
        let moduleData = this.offerData.stepsConstantData[this.currentModuleNumber - 1];
        return {
          version: this.offerData.version,
          step: step,
          module: this.currentModuleNumber,
          bidderFundings: moduleData.bidderFundings,
        };
      },

      prepareGenericPersistentFormDTO(step) {
        return {
          version: this.offerData.version,
          step: step,
          form: genericFormUtil.encodeSchema(JSON.parse(JSON.stringify(this.offerData.genericModel))),
        };
      },

      prepareGenericModuleFormDTO(step) {
        return {
          version: this.offerData.version,
          step: step,
          module: this.currentModuleNumber,
          form: genericFormUtil.encodeSchema(JSON.parse(JSON.stringify(this.offerData.moduleGenericModel[this.currentModuleNumber]))),
        };
      },
		},
	}
	;
</script>
<style scoped>
	.stepTitle {
		margin: 20px;
	}

	.v-btn .v-btn__content .v-icon {
		color: #fff !important;
	}

	.financialHint {
		margin-left: 20px;
		font-style: italic;
		font-size: 12px;
		white-space: pre;
		display: flex;
	}
</style>
<style>
	.contest-offer-view-content fieldset .form-group.field-checkbox {
		flex-wrap: wrap;
	}

	.contest-offer-view-content .errors.help-block {
		flex: 1 0 95%;
		order: 5;
		margin-left: 28px;
	}

	.contest-offer-view-content .form-group.field-checkbox > label {
		flex: 1 0 95%;
	}

	.contest-offer-view-content .form-group.field-checkbox .hint {
		flex: 1 0 95%;
	}
</style>
